// @flow

export const SET: 'PLANE.SET' = 'PLANE.SET';
export const UNSET: 'PLANE.UNSET' = 'PLANE.UNSET';
export const BATCH_SET: 'PLANE.BATCH_SET' = 'PLANE.BATCH_SET';
export const END_SESSION: 'PLANE.END_SESSION' = 'PLANE.END_SESSION';